<div class="dialog-header flex flex-row aic" *ngIf="!customContent; else customHeaderContent">
  <h4 class="gus-common-dialog-title text-transform-uppercase space-letter-059 line-height-24 fs20">{{ config.title }}</h4>

  @if (config.hasCloseButton) {
    <!-- <gus-circle-close-icon (click)="closeDialog.emit()" class="gus-cursor-pointer"></gus-circle-close-icon> -->
    <div class="oval flex flex-nosize jcc aic gus-cursor-pointer" (click)="closeDialog.emit()">
      <gus-icon name="close" class="flex-nosize" width="18px" height="17px" ></gus-icon>
    </div>
  }
</div>

<ng-template #customHeaderContent>
  <ng-content select="[gusCustomDialogContent]"></ng-content>
</ng-template>
